module.exports = __webpack_public_path__ + "img/full6-min.4c54f5e7.png";